export const BROADCAST_CHANNELS = {
  CHANNEL_ALL: 'ukasko.notifications.all',
  MAIN_CLIENTS: 'ukasko.notifications.mainClients',
  CHILD_CLIENTS: 'ukasko.notifications.childClients',
  INDIVIDUAL_CLIENTS: 'ukasko.notifications.individuals',
  ENTREPRENEUR_CLIENTS: 'ukasko.notifications.entrepreneurs',
  LLC_CLIENTS: 'ukasko.notifications.llc',
};

export const NOTIFICATION_TYPES = {
  NOTIFICATION_ADD: '.notification.add',
};
